import { REACT_APP_API_URL } from '@/helpers/conf';
import {
  CASINO_PAYMENTS_REDIRECT_ROUTES,
  CDN_URLS,
  CLIENT_ENVS,
  SPORTS_PAYMENTS_REDIRECT_ROUTES,
} from '@/helpers/constants';
import { SPORTS_ROUTES } from '@/modules/sports/helpers';

export let isPaymentLibConfigured = false;

export const configPaymentsLib = () => {
  const origin = window.location.origin;
  const language = document.documentElement.lang || 'en';
  const isSports = window.location.pathname.includes(SPORTS_ROUTES);
  const redirectRoutes = isSports
    ? SPORTS_PAYMENTS_REDIRECT_ROUTES
    : CASINO_PAYMENTS_REDIRECT_ROUTES;

  window.PaymentsAPI?.config({
    ...(CLIENT_ENVS.APP_ENV !== 'development' && {
      serverUrl: REACT_APP_API_URL,
    }),
    language,
    cdnList: CDN_URLS,
    contentPolicy: '3',
    redirectRoutes: {
      successUrl: `${origin}${redirectRoutes.SUCCESS}`,
      failureUrl: `${origin}${redirectRoutes.FAILURE}`,
      pendingUrl: `${origin}${redirectRoutes.PENDING}`,
      supportUrl: `${origin}${redirectRoutes.SUPPORT}`,
    },
  })
    .then(() => {
      console.log('usePaymentsAPIReady:configPaymentsLib');
      if (window.PaymentsAPI) {
        isPaymentLibConfigured = true;
      }
    })
    .catch((error) => {
      console.error('usePaymentsAPIReady:configPaymentsLib error', error);
    });
};
